import React from "react"

export const IconTg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_518_441)">
      <path
        d="M10.0527 13.9459C9.79993 14.1729 9.81951 14.5747 10.0931 14.776L16.2324 19.293C16.9914 19.716 17.5261 19.4932 17.7309 18.5947L20.4473 5.86596C20.6881 4.74398 20.0423 4.30448 19.3029 4.57973L3.33562 10.6929C2.24589 11.1159 2.26239 11.7234 3.15037 11.9986L6.76293 13.1223C7.06106 13.215 7.3848 13.1731 7.64948 13.0075L16.7146 7.33518C17.1609 7.03969 17.5666 7.20319 17.2329 7.49868L10.0527 13.9459Z"
        fill="#02020C"
      />
    </g>
    <defs>
      <clipPath id="clip0_518_441">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
